import { render, staticRenderFns } from "./view-model.vue?vue&type=template&id=1172daeb&scoped=true&"
import script from "./view-model.vue?vue&type=script&lang=ts&"
export * from "./view-model.vue?vue&type=script&lang=ts&"
import style0 from "./view-model.vue?vue&type=style&index=0&id=1172daeb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1172daeb",
  null
  
)

export default component.exports